var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// db/CustomContent.ts
import { Entity, Field, Query } from "@adornis/baseql/decorators.js";
import { MongoEntity } from "@adornis/baseql/entities/mongoEntity.js";
import { getCollection } from "@adornis/baseql/server/collections.js";
import { selectionSet } from "@adornis/baseql/utils/queryGeneration.js";
import { validate } from "@adornis/validation/decorators.js";
import { nonOptional } from "@adornis/validation/functions/nonOptional.js";
import { Base } from "./Base.js";
import { PageStatus } from "./enums.js";
var CustomContent = class extends MongoEntity {
  static get allFields() {
    return selectionSet(() => this, 4);
  }
  static getAllActiveCustomContents() {
    return async (gqlFields) => {
      const collection = await getCollection(this._class);
      const result = await collection.find({ status: { $eq: PageStatus.PUBLISHED } }).toArray();
      return result;
    };
  }
};
CustomContent._class = "CustomContent";
CustomContent._collectionName = "custom-contents";
__decorateClass([
  validate(nonOptional()),
  Field((type) => String)
], CustomContent.prototype, "name", 2);
__decorateClass([
  Field((type) => String)
], CustomContent.prototype, "icon", 2);
__decorateClass([
  validate(nonOptional()),
  Field((type) => [Base], { default: (v) => v ?? [] })
], CustomContent.prototype, "content", 2);
__decorateClass([
  validate(nonOptional({ allowFalsy: true })),
  Field((type) => Boolean, { default: (v) => v ?? false })
], CustomContent.prototype, "isTemplate", 2);
__decorateClass([
  validate(nonOptional()),
  Field((type) => String, { default: (v) => v ?? PageStatus.IN_PROGRESS })
], CustomContent.prototype, "status", 2);
__decorateClass([
  Query((type) => [CustomContent])
], CustomContent, "getAllActiveCustomContents", 1);
CustomContent = __decorateClass([
  Entity()
], CustomContent);
export {
  CustomContent
};
